import {
  ref,
  onMounted,
  defineComponent,
  reactive,
  computed,
} from "@vue/composition-api";
import { v4 as uuidv4 } from "uuid";

import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation.vue";

import { newSortOrderValue } from "@/utilities/sortOrder";

import { TemplateWorkOrderTask } from "@/store/modules/templateWorkOrderTasks";
import TemplateWorkOrderBuildTaskEditForm from "@/components/TemplateWorkOrders/TemplateWorkOrderBuildTaskEditForm.vue";

import { TemplateWorkOrderTaskLineItem } from "@/store/modules/templateWorkOrderTaskLineItems";

import { LineItem } from "@/store/modules/lineItems";

import { JSConn } from "@/utilities/js-conn";

import { TemplateWorkOrder } from "@/store/modules/templateWorkOrders";

export default defineComponent({
  name: "buildTemplateWorkWorkOrder",
  components: {
    LoadingAnimation,
    TemplateWorkOrderBuildTaskEditForm,
  },

  props: {
    templateWorkOrderId: {
      type: String,
      required: true,
    },
  },

  setup(props, ctx) {
    let $store = ctx.root.$store;

    const dataLoaded = ref(false);
    const secondDataLoaded = ref(false);
    const loadingMessage = ref("Preparing the form...");

    const editingTaskId = ref("");
    const selectedTaskId = ref("");

    const templateWorkOrder = computed(() => {
      return $store.getters.templateWorkOrder as TemplateWorkOrder;
    });

    const newTask = reactive<TemplateWorkOrderTask>({
      id: "new",
      name: "",
      description: "",
      sort_order: 200,
      template_work_order_id: props.templateWorkOrderId,
      template_work_order_task_line_items: [],
    });

    const templateWorkOrderTasks = computed(() => {
      return $store.getters.templateWorkOrderTasks as TemplateWorkOrderTask[];
    });

    const lineItems = computed(() => {
      return $store.getters.lineItems;
    });

    const editTask = (task: TemplateWorkOrderTask) => {
      if (editingTaskId.value === task.id) {
        editingTaskId.value = "";
      } else {
        editingTaskId.value = task.id;
      }
    };

    const editTaskSuccessful = (
      _task: TemplateWorkOrderTask | TemplateWorkOrderTaskLineItem,
    ) => {
      editingTaskId.value = "";
      newTask.id = "new";
      newTask.name = "";
      newTask.description = "";
      reloadTemplateWorkOrder();
    };

    const selectTask = (task: TemplateWorkOrderTask) => {
      if (selectedTaskId.value === task.id) {
        selectedTaskId.value = "";
      } else {
        selectedTaskId.value = task.id;
      }
    };

    const moveTask = (
      direction: "up" | "down",
      task: TemplateWorkOrderTask,
    ) => {
      const newSortOrder = newSortOrderValue(task, direction, [
        ...templateWorkOrderTasks.value,
      ]);
      if (newSortOrder.noChangeNeeded) {
        return;
      } else {
        const jsConn = new JSConn();
        jsConn.formParams = {
          id: task.id,
          sort_order: newSortOrder.newSortOrder,
        };

        $store.dispatch("updateTemplateWorkOrderTask", jsConn).then(() => {
          // ctx.emit("tasksChanged");
          reloadTemplateWorkOrder();
        });
      }
    };

    const deleteTask = (task: TemplateWorkOrderTask) => {
      const jsConn = new JSConn();
      jsConn.formParams = task;
      $store.dispatch("deleteTemplateWorkOrderTask", jsConn).then(() => {
        reloadTemplateWorkOrder();
      });
    };

    const deleteLineItem = (lineItem: TemplateWorkOrderTaskLineItem) => {
      const jsConn = new JSConn();
      jsConn.formParams = lineItem;
      $store
        .dispatch("deleteTemplateWorkOrderTaskLineItem", jsConn)
        .then(() => {
          reloadTemplateWorkOrder();
        });
    };

    const reloadTemplateWorkOrder = () => {
      let dataPromises = [];
      const jsConn = new JSConn();

      jsConn.formParams = {
        id: props.templateWorkOrderId,
      };

      dataPromises.push($store.dispatch("needTemplateWorkOrder", jsConn));

      jsConn.formParams = {
        id: props.templateWorkOrderId,
      };

      Promise.all(dataPromises).finally(() => {
        dataLoaded.value = true;
      });
    };

    onMounted(() => {
      reloadTemplateWorkOrder();

      let secondPanePromises = [];
      const jsConnLineItems = new JSConn();

      secondPanePromises.push(
        $store.dispatch("needLineItems", jsConnLineItems),
      );

      Promise.all(secondPanePromises).finally(() => {
        secondDataLoaded.value = true;
      });
    });

    const selectedRowClassObject = (task: TemplateWorkOrderTask) => {
      let isRowSelected = false;
      if (task.id === selectedTaskId.value) {
        isRowSelected = true;
      } else {
        isRowSelected = false;
      }

      return {
        "hb-selected-row": isRowSelected,
      };
    };

    const addToSelectedTask = (lnItem: LineItem) => {
      if (selectedTaskId.value !== "") {
        const jsConn = new JSConn();
        jsConn.formParams = {
          id: uuidv4(),
          template_work_order_task_id: selectedTaskId.value,
          line_item_id: lnItem.id,
          sort_order: 200,
        };

        $store
          .dispatch("createTemplateWorkOrderTaskLineItem", jsConn)
          .then(() => {
            reloadTemplateWorkOrder();
          });
      }
    };

    return {
      dataLoaded,
      secondDataLoaded,
      loadingMessage,
      newTask,

      editTaskSuccessful,

      moveTask,
      deleteTask,

      deleteLineItem,

      templateWorkOrder,
      templateWorkOrderTasks,

      lineItems,

      editTask,
      editingTaskId,

      selectTask,
      selectedTaskId,
      selectedRowClassObject,

      addToSelectedTask,
    };
  },
});
